module.exports = __webpack_public_path__ + "img/checkmark.93c339b3.svg";